import { config } from '../../configuration/config';
import { fetchHereSettingsFailed, hereSettingsChanged } from '../../store/data/dataSlice';
import type { RootDispatch } from '../../configuration/setup/store';

export const API_CONF_ENDPOINT = '/configurations';

export const fetchHereSettings = (dispatch: RootDispatch) => {
    try {
        const hereSettings = { apikey: `${config.backend.MAP_SERVICE_API_KEY}` };
        dispatch(hereSettingsChanged(hereSettings));
    } catch (error) {
        dispatch(fetchHereSettingsFailed(error));
    }
};
